import { ApplicationElement, html } from '../application_element/element.js';
import '../icon_block/element.js';

/**
 * A button with icon
 * @prop as - button class (optional)
 * @prop icon - icon name (optional)
 * @prop text - translated text to appear on button (optional)
 * @prop href - Url to which this button points (optional)
 * @prop innerClass - A custom class given to anchor element that wraps the button (optional)
 *
 */
export default class IconButton extends ApplicationElement {
  static properties = {
    as: { type: String },
    icon: { type: String },
    text: { type: String },
    href: { type: String },
    layout: { type: String },

    remote: { type: Boolean },
    method: { type: String },
    innerClass: { type: String },
  };

  createRenderRoot() {
    return this;
  }

  get translatedText() {
    return this.text;
  }

  renderIcon() {
    return html`<ef-icon name=${this.icon}></ef-icon>`;
  }

  renderText() {
    return html`<span>${this.translatedText}</span>`;
  }

  render() {
    return html`
      <a
        class="${this.innerClass} btn-${this.as}"
        @click=${this.onClick}
        href="${this.href}">
        ${this.icon ? this.renderIcon() : null}
        ${this.translatedText ? this.renderText() : null}
      </a>
    `;
  }
}

customElements.get('ef-icon-button') ||
  customElements.define('ef-icon-button', IconButton);
